export const UPLOAD_SUCCESS_MESSAGE =
  'Your file has been successfully uploaded';
export const UPLOAD_LOCALSTORAGE_KEY = 'assets:csv:upload';
